<template>
<div class="row">
  <div class="Absolute-Center is-Responsive">
    <div id="logo-container"></div>
    <h1>Thank You For your response!</h1>
    <br />
  </div>    
</div>
</template>

<script>
export default {
  methods: {
    goToHome() {
      this.$router.push({ name: 'chart' })
    }
  }
}
</script>